import React from 'react';
import useSettings from '../../../hooks/useSettings';
import {
	TemplateBoolean,
	TemplateCheckbox,
	TemplateDropdown,
	TemplateField,
	TemplateImage,
} from '../../../components/Attributes/Attributes_old';
import useAsync from '../../../hooks/useAsync';
import { getModuleFields, getModuleFieldsBeta } from '../../../api/modules';
import Button from '../../../components/Button';
import { QrCodeIcon } from '@heroicons/react/24/outline';
import QRCode from 'react-qr-code';
import useLocal from '../../../hooks/useLocal';

const ASSETS_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const UserSettings = () => {
	const { get: getSetting, set: setSetting } = useSettings();
	const { get: getLocalData } = useLocal();

	const { value: moduleFields } = useAsync(getModuleFields, {
		defaultPayload: { id: ASSETS_MODULE_ID },
	});

	const assetMainColumn = getSetting('assetMainColumn');
	const userLandingPage = getSetting('userLandingPage');

	const NODE_ENV = process.env.REACT_APP_ENVIRONMENT;

	const QRURL = `${
		NODE_ENV === 'development'
			? 'http://localhost:8080'
			: NODE_ENV === 'stage'
			? 'https://stage.cloud.scipods.com'
			: 'https://cloud.scipods.com'
	}/c/${getLocalData('user')?.organization?.id || '0'}`;

	const MAIN_COLUMN_OPTIONS = [
		{ label: 'Manufacturer', value: 'default' },
		...(moduleFields?.length
			? moduleFields
					?.filter((attr) => ['manufacturer', 'model'].indexOf(attr?.key) < 0)
					.map((attr) => ({
						value: attr?.isDefault ? attr?.key : attr.id,
						label: attr.label,
					}))
			: []),
	];

	const LANDING_PAGE_OPTIONS = [
		{ label: 'Dashboard', value: 'default' },
		{ label: 'All Assets', value: 'allAssets' },
	];

	return (
		<>
			<div>
				<h2 className="text-base font-semibold leading-6 text-gray-900">
					UX Preferences
				</h2>
				<div className="divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
					<div className="grid grid-cols-3 flex items-center py-5">
						<div className="col-span-2">
							<span className="flex flex-grow flex-col">
								<span className="text-xs font-medium text-gray-900">
									Landing Page
								</span>
								<span className="text-xxs text-gray-500 text-xs font-normal">
									When loading the app, which page should the default path route
									to
								</span>
							</span>
						</div>
						<div className="col-span-1">
							<TemplateDropdown
								className={'w-72'}
								options={LANDING_PAGE_OPTIONS}
								value={userLandingPage?.value || 'default'}
								onChange={(index, value, raw) => {
									if (value) {
										setSetting('user', 'userLandingPage', raw, {
											showNotification: false,
										});
									} else {
										setSetting('user', 'userLandingPage', null, {
											showNotification: false,
										});
									}
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default UserSettings;
